import ApiKeyHelper from '@/helper/ApiKeyHelper'
import ApiKey from '@/models/ApiKey'

export default {
  data () {
    return {
      lists: {
        affiliates: [],
        adspaces: []
      },
      newForm: {
        valid: false,
        loading: false,
        dialog: false,
        fields: {}
      },
      editForm: {
        valid: false,
        loading: false,
        dialog: false,
        fields: {}
      },
      removeForm: {
        dialog: false,
        fields: {
          _id: null
        }
      },
      rules: {},
      headers: [
        {
          sortable: true,
          text: 'Networks',
          value: 'affiliate_id',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Adspace',
          value: 'adspace_id',
          align: 'left'
        },
        {
          sortable: true,
          text: 'API Key',
          value: 'api_key',
          align: 'left'
        },
        {
          sortable: true,
          text: 'API Secret',
          value: 'api_secret',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Extra',
          value: 'extra',
          align: 'left'
        },
        {
          sortable: true,
          text: '',
          value: '',
          align: 'left'
        }
      ],
      filters: {},
      items: []
    }
  },
  beforeMount () {
    this.lists.affiliates = JSON.parse(localStorage.getItem('affiliates'))
    this.lists.adspaces = JSON.parse(localStorage.getItem('adspaces'))

    this.rules = ApiKey.validators()

    this.newForm.fields = ApiKey.parserFrom({}).attrs
    this.editForm.fields = ApiKey.parserFrom({}).attrs

    this.loadItems()
  },
  methods: {
    // Load items.
    loadItems: async function () {
      await ApiKeyHelper.load().then((res) => {
        this.items = res.map((item) => ApiKey.parserFrom(item).attrs)
      })
    },
    // External persistence.
    save: function () {
      if (this.$refs.new.validate()) {
        ApiKey.parserFrom(this.newForm.fields).save()
          .then(() => {
            this.newForm.dialog = false
            this.loadItems()
          })
      }
    },
    edit: function (data) {
      this.editForm.fields = ApiKey.parserFrom(data).attrs
      this.editForm.dialog = true
    },
    update: function () {
      if (this.$refs.edit.validate()) {
        ApiKey.parserFrom(this.editForm.fields).update()
          .then(() => {
            this.editForm.dialog = false
            this.loadItems()
          })
      }
    },
    removeConfirm: function (data) {
      this.removeForm.fields._id = data._id
      this.removeForm.dialog = true
    },
    remove: function () {
      ApiKey.parserFrom(this.removeForm.fields).delete()
        .then(() => {
          this.removeForm.id = null
          this.loadItems()
        })
        .finally(() => this.removeForm.dialog = false)
    }
  }
}
